.skeleton {
  animation: skeleton-loading 1s linear infinite alternate;
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(200, 20%, 80%);
  }
  100% {
    background-color: hsl(200, 20%, 95%);
  }
}

.skeleton-text {
  width: 100%;
  height: 0.7rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
}

.skeleton-h2 {
  width: 100%;
  height: 1.8rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
}

.skeleton-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.skeleton-h3 {
  width: 11rem;
  height: 1.4rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
}

.skeleton-h3-long {
  width: 100%;
  height: 1.4rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
}

.skeleton-h3-medium {
  width: 20rem;
  height: 1.4rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
}

.skeleton-h3-short {
  width: 7rem;
  height: 1.4rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
}

.skeleton-text__body {
  width: 75%;
}

.skeleton-footer {
  width: 30%;
}

$grid-gutter-width: 65px;

.lod-hidden {
  display: none !important;
}

@media (max-width: 959px) {
  .lod-mobile-hidden {
    display: none !important;
  }
}

@media (max-width: 959px) {
  .lod-full-width-mobile {
    width: 100% !important;
  }
}

.lod-full-width {
  width: 100% !important;
}

@media (min-width: 960px) {
  .lod-description-row {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    word-break: normal;
  }
}
